export const COLLAPSE_MAX_STRINGS_BEFORE_COLLAPSE = 4;
export const COLLAPSE_LINE_HEIGHT = 24;
